
import React, { useState ,useEffect} from 'react';
import CustomButton from '../../../../component/elements/CustomButton/CustomButton';
import CloseIcon from '@mui/icons-material/Close';
import TextFieldCustom from '../../../../component/elements/textfieldCustom';

function AddNote({ onClose, dialogDetails, onSubmit }) {
   const [noteValue, setNoteValue] = useState(dialogDetails.defaultValue);
  useEffect(() => {
    setNoteValue(dialogDetails.defaultValue);
  }, [dialogDetails.defaultValue]);

  const handleChange = (event) => {
    setNoteValue(event.target.value);
  };
    return (
        <div className="pt-6 px-4" >
            <div className="flex justify-end mb-2">
                <button
                    className=" text-gray-600 hover:text-black"
                    onClick={onClose}
                    aria-label="Close"
                >
                    <CloseIcon />
                </button>
            </div>
            <div className='flex flex-col w-full justify-center items-center' >
                <TextFieldCustom
                    label="Add note*"
                    heightClass={"custom-textarea-height"}
                    fullWidth
                    multiline
                    value={noteValue}
                    onChange={handleChange}
                />
                <div className="flex justify-center items-center mt-8 mb-4">
                    <CustomButton
                        onClick={() => onSubmit(noteValue)}
                        customeClass={`gradient-button w-full sm:w-[150px] h-[40px]`}
                    >
                        Submit
                    </CustomButton>
                </div>
            </div>
        </div>
    );
}

export default AddNote;